import { render, staticRenderFns } from "./WordLink.vue?vue&type=template&id=5474a866&scoped=true&"
import script from "./WordLink.vue?vue&type=script&lang=js&"
export * from "./WordLink.vue?vue&type=script&lang=js&"
import style0 from "./WordLink.vue?vue&type=style&index=0&id=5474a866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474a866",
  null
  
)

export default component.exports